export default __webpack_public_path__ + "static/media/sagittarius.4a9e66ed.png";